﻿<div *ngIf="accountSettingsLoaded && notesAccountSettingItems.length !== 0">
    <!-- <div class="page-sub-header"> -->
    <div class="sub-section-header">
        <h1 class="title">Notes</h1>
        <span class="actions">
            Last Updated: <span *ngIf="lastUpdated; else never">{{ lastUpdated | date: 'M/d/yy, h:mm a' }}</span>
            <ng-template #never>Never</ng-template>
        </span>
    </div>

    <form [formGroup]="workbenchNotesForm" novalidate autocomplete="off">
        <ng-container *ngFor="let item of notesAccountSettingItems; let i = index">
            <mat-card *ngIf="i === 0" class="account-setting" style="margin-bottom: 25px;" appearance="outlined">
                <mat-card-content style="display: flex; flex-direction: column; gap:16px;">
                    <mat-slide-toggle [formControlName]="item.formControlName" [name]="item.formControlName"
                        (change)="onToggleFeature($event)">
                        {{ item.accountSettingTitle }}
                    </mat-slide-toggle>
                    <span>{{ item.accountSettingDescription }}</span>
                </mat-card-content>
            </mat-card>

            <mat-card *ngIf="i === 1 && isEditableNoteFeatureEnabled" class="account-setting" appearance="outlined">
                <mat-card-content style="display: flex; flex-direction: column; gap:16px;">
                    <mat-slide-toggle [formControlName]="item.formControlName" [name]="item.formControlName"
                        (change)="onToggleFeature($event)">
                        {{ item.accountSettingTitle }}
                    </mat-slide-toggle>
                    <mat-form-field style="width: 25rem;;">
                        <mat-label>Allow Notes to be edited</mat-label>
                        <mat-select [formControl]="workbenchNotesForm.get(notesAccountSettingItems[2]?.formControlName)"
                            (selectionChange)="handleChange($event, notesAccountSettingItems[2]?.formControlName)">
                            <mat-option *ngFor="let opt of notesAccountSettingItems[2]?.dropdownOptions"
                                [value]="opt.value">
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </form>
</div>


<!-- Templates -->
<ng-template let-data #disableWarningDialog>
    <div mat-dialog-content>
        <div>
            <div class="dialog-title" style="margin-bottom: 10px;">{{ data.title }}</div>
            <div class="content flex flex-column">{{ data.content }}</div>
        </div>
    </div>
    <mat-dialog-actions align="end">
        <mrs-btn-tertiary (click)="handleClose()" buttonId="closeDialog" textColor="#2C6EED" buttonLabel="OKAY"> </mrs-btn-tertiary>
    </mat-dialog-actions>
</ng-template>